import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { appRoutes } from "./app.routes";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { ENVIRONMENT, MaterialModule, MobiOfficeUiModule } from "@mobi-office-ui";
import { ToastrModule } from "ngx-toastr";
import { environment } from "@environment/vm-admin-ui/environment";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { appFactory, AppService } from "../services/app.service";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { SharedModule } from "./shared/shared.module";
import { MainInterceptor } from "./middleware/main.interceptor";
import { CustomPopupComponent } from "../components/custom-popup/custom-popup.component";
import { DashboardComponent } from "./startup/dashboard/dashboard.component";
import { LoginComponent } from "./startup/login/login.component";
import { PageNotFoundComponent } from "./startup/page-not-found/page-not-found.component";
@NgModule({
  declarations: [AppComponent, DashboardComponent, LoginComponent, PageNotFoundComponent, CustomPopupComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    MobiOfficeUiModule,
    FormsModule,
    SharedModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: "enabledBlocking", useHash: true, onSameUrlNavigation: "reload", scrollPositionRestoration: "top" }),
    StoreModule.forRoot({}),
    EffectsModule.forRoot({}),
    !environment.PRODUCTION
      ? StoreDevtoolsModule.instrument({
          maxAge: 25,
          logOnly: environment.PRODUCTION,
          connectInZone: true,
        })
      : [],
    ToastrModule.forRoot({
      progressBar: true,
      autoDismiss: true,
      timeOut: 3000,
      positionClass: "toast-top-right",
    }),
    HttpClientModule,
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = appFactory(inject(AppService));
      return initializerFn();
    }),
    { provide: ENVIRONMENT, useValue: environment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
